export default __webpack_public_path__ + "static/media/1_Conservative.29229ccc.png";